

export class AuthenticatedUserDto implements IAuthenticatedUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;
    profileImageUri!: string | undefined;
    token!: string | undefined;
    employeeId!: number;
    designationName!: string | undefined;
    isClarify!: boolean | undefined;
    isPasswordChange!: boolean | undefined;
    isApprover!: boolean | undefined;

    constructor(data?: IAuthenticatedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.profileImageUri = _data["profileImageUri"];
            this.token = _data["token"];
            this.employeeId = _data["employeeId"];
            this.designationName = _data["designationName"];
            this.isClarify = _data["isClarify"];
            this.isPasswordChange = _data["isPasswordChange"];
            this.isApprover = _data["isApprover"];
        }
    }

    static fromJS(data: any): AuthenticatedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticatedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["profileImageUri"] = this.profileImageUri;
        data["token"] = this.token;
        data["employeeId"] = this.employeeId;
        data["designationName"] = this.designationName;
        data["isClarify"] = this.isClarify;
        data["isPasswordChange"] = this.isPasswordChange;
        data["isApprover"] = this.isApprover;
        return data; 
    }
}

export interface IAuthenticatedUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
    profileImageUri: string | undefined;
    token: string | undefined;
    employeeId: number;
    designationName: string | undefined;
    isClarify: boolean | undefined;
    isPasswordChange: boolean | undefined;
    isApprover: boolean | undefined;
}

